import { makeStyles, tokens } from "@fluentui/react-components";
import { ellipsis } from "@/common/style/commonStyle";
import { WorkspaceSizeThresholds } from "@/common/constants";

export const useComponentStyle = makeStyles({
	root: {
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				height: "60px",
				justifyContent: "flex-start",
			},
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
			{
				justifyContent: "center",
			},

		[`@media (max-width: 440px)`]: {
			paddingLeft: "24px",
		},
	},
	interactionWrapUpIconColor: {
		color: tokens.colorNeutralForegroundDisabled,
	},
	interactionInfoContainer: {
		marginRight: "12px",
	},
	minWidthZero: {
		minWidth: 0,
	},
	dialpadButton: {
		marginTop: "4px",
	},
	interactionInfo: {
		color: tokens.colorStrokeFocus2,
		minWidth: "150px",
		...ellipsis(),
	},
	arrow: {
		paddingRight: "16px",
		color: tokens.colorNeutralForeground1,
	},
	infoIcon: {
		marginRight: "10px",
		marginLeft: "10px",
		cursor: "pointer",
		color: tokens.colorNeutralForeground3,
	},
});
